var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDesignConsideration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7724_18072",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7724_18072)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.99935 28L8.66602 25.0667L12.466 14.6C12.7993 14.9111 13.1605 15.1722 13.5493 15.3833C13.9382 15.5944 14.3549 15.7556 14.7993 15.8667L11.1327 25.9333L8.99935 28ZM22.9993 28L20.866 25.9333L17.1993 15.8667C17.6438 15.7556 18.0605 15.5944 18.4493 15.3833C18.8382 15.1722 19.1994 14.9111 19.5327 14.6L23.3327 25.0667L22.9993 28ZM15.9993 14.6667C14.8882 14.6667 13.9438 14.2778 13.166 13.5C12.3882 12.7222 11.9993 11.7778 11.9993 10.6667C11.9993 9.8 12.2493 9.02778 12.7493 8.35C13.2493 7.67222 13.8882 7.2 14.666 6.93333V4H17.3327V6.93333C18.1105 7.2 18.7493 7.67222 19.2493 8.35C19.7493 9.02778 19.9993 9.8 19.9993 10.6667C19.9993 11.7778 19.6105 12.7222 18.8327 13.5C18.0549 14.2778 17.1105 14.6667 15.9993 14.6667ZM15.9993 12C16.3771 12 16.6938 11.8722 16.9493 11.6167C17.2049 11.3611 17.3327 11.0444 17.3327 10.6667C17.3327 10.2889 17.2049 9.97222 16.9493 9.71667C16.6938 9.46111 16.3771 9.33333 15.9993 9.33333C15.6216 9.33333 15.3049 9.46111 15.0493 9.71667C14.7938 9.97222 14.666 10.2889 14.666 10.6667C14.666 11.0444 14.7938 11.3611 15.0493 11.6167C15.3049 11.8722 15.6216 12 15.9993 12Z",
    fill: "#1D1D1D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesignConsideration);
export default __webpack_public_path__ + "static/media/design-consideration.30e56110afb398c0463e34ac4c318249.svg";
export { ForwardRef as ReactComponent };